import { AreaSeries } from './AreaSeries';

export class StackedAreaSeries extends AreaSeries {
    crosshairLabel(bisect, date, valueFormatter): string {
        let label = '';
        const currentValue = this.data()[bisect(this.data(), date)];
        if (currentValue) {
            label = this.legendText() + ': ' + valueFormatter(this.y1(currentValue) - this.y0(currentValue));
        }
        return label;
    }
}